<script setup>
import { useAiHandoff } from 'dashboard/composables/useAiHandoff';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  conversation: { type: Object, required: true },
});

const { returnToAI, resetConversation } = useAiHandoff();
</script>

<template>
  <div class="flex flex-col gap-2 p-3 border-t border-n-weak">
    <Button
      faded
      color="teal"
      icon="i-lucide-bot"
      :label="$t('CONVERSATION_SIDEBAR.AI_HANDOFF.RETURN_TO_AI')"
      class="w-full justify-center"
      @click="returnToAI(conversation)"
    />
    <Button
      faded
      color="amber"
      icon="i-lucide-rotate-ccw"
      :label="$t('CONVERSATION_SIDEBAR.AI_HANDOFF.RESET')"
      class="w-full justify-center"
      @click="resetConversation(conversation)"
    />
  </div>
</template>
